import { Job } from "~/components/build/Show/lib/types";
import Notice from "~/components/shared/Notice";

interface Props {
  job: Job;
}

export const StackErrored = ({ job }: Props) => {
  if (!job.stackErrored) {
    return null;
  }

  const message = "This job has been marked as failed by agent stack.";
  const type = job.softFailed ? "warning" : "error";

  return (
    <div className="pb-4 pt-4">
      <Notice title={message} noticeType={type} icon="heroicons/16/solid/exclamation-triangle">
        <p>
          {" "}
          Check the <strong>Timeline</strong> tab for more information.{" "}
        </p>
      </Notice>
    </div>
  );
};
